<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link
        icon="el-icon-arrow-left"
        :underline="false"
        href="#/businessPartnerManagement"
        >Business Partner Management</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">
      Edit Business Partner Account
    </h3>
    <div class="detailContent">
      <div class="requireRmarks">*Required Fields</div>
      <el-form
        label-width="50%"
        label-position="left"
        ref="formAccount"
        :model="formAccount"
        :rules="formAccountRules"
      >
        <el-row>
          <h4>Profile</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Vendor ID/Employee ID" prop="clientID">
              <p>{{ formAccount.clientID }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formAccount.userStatus != 'OPENED'">
            <el-form-item label="Username">
              <p>{{ formAccount.userName }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12" v-if="formAccount.sfRecordType !== 'CP'">
            <el-form-item
              v-if="formAccount.isDummyUser"
              label="Last Name"
              prop="lastName"
              :error="formAccount.lastName ? '' : 'Last Name cannot be empty'"
            >
              <el-input
                v-model="formAccount.lastName"
                maxlength="50"
              ></el-input>
            </el-form-item>

            <el-form-item v-else label="Last Name">
              <p>{{ formAccount.lastName ? formAccount.lastName : "-" }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formAccount.sfRecordType !== 'CP'">
            <el-form-item label="First Name" prop="firstName">
              <el-input
                v-model="formAccount.firstName"
                maxlength="50"
                v-if="formAccount.isDummyUser"
              ></el-input>
              <p v-else>
                {{ formAccount.firstName ? formAccount.firstName : "-" }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <h4>General Information</h4>
        </el-row>
        <div class="border-box">
          <el-row :gutter="50">
            <el-col :span="12" v-if="!formAccount.isDummyUser">
              <el-form-item label="Mobile Phone" prop="salesforcePhone">
                <p>
                  {{
                    formAccount.cellularphone ? formAccount.cellularphone : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="!formAccount.isDummyUser">
              <el-form-item label="Buiness Phone" prop="buinessPhone">
                <p>
                  {{ formAccount.phone ? formAccount.phone : "-" }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12" v-if="!formAccount.isDummyUser">
              <el-form-item
                label="Salesforce Email address"
                prop="salesforceEmail"
              >
                <p>
                  {{
                    formAccount.salesforceEmail
                      ? formAccount.salesforceEmail
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Preferred Language" prop="preferredLanguage">
                <p>
                  {{
                    formAccount.salesforceLanguage
                      ? formAccount.salesforceLanguage
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <h4>Setting</h4>
        </el-row>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Market updates" prop="Market updates">
                {{
                  formAccount.marketUpdates ? formAccount.marketUpdates : "-"
                }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Corporate" prop="Corporate">
                {{ formAccount.corporate ? formAccount.corporate : "-" }}
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <h4>Sales Information</h4>
        </el-row>
        <div class="border-boxshadow">
          <div>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="Sales Office">
                  <p>{{ $commonjs.salesOfficeMap(formAccount.salesOffice) }}</p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Region">
                  <p>{{ $commonjs.regionMap(formAccount.region) }}</p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Sales Representative Name">
                  <p>
                    {{
                      formAccount.representativeName
                        ? formAccount.representativeName
                        : "-"
                    }}
                  </p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Record Type">
                  <p>
                    {{ safeGetNameField(formAccount.salesforceRecordType) }}
                  </p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Salesforce Region">
                  <p>
                    {{ safeGetNameField(formAccount.salesforceRegion) }}
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="Referral Company / Individual Planner">
                  <p>
                    {{
                      formAccount.salseforceServicingChannelName
                        ? formAccount.salseforceServicingChannelName
                        : "-"
                    }}
                  </p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Referral Planner /  Broker">
                  <p>
                    {{
                      formAccount.salseforceServicingFinancialPlanner
                        ? formAccount.salseforceServicingFinancialPlanner
                        : "-"
                    }}
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="Sub-Referral Company">
                  <p>
                    {{
                      formAccount.salseforceReferredByIfa
                        ? formAccount.salseforceReferredByIfa
                        : "-"
                    }}
                  </p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Sub-Referral Planner">
                  <p>
                    {{
                      formAccount.salseforceReferredByPlanner
                        ? formAccount.salseforceReferredByPlanner
                        : "-"
                    }}
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="Referred By (Client LV)">
                  <p>
                    {{
                      formAccount.salseforceReferredByClientLv
                        ? formAccount.salseforceReferredByClientLv
                        : "-"
                    }}
                  </p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Servicing Channel Type">
                  <p>
                    {{
                      formAccount.salseforceServicingChannelType
                        ? formAccount.salseforceServicingChannelType
                        : "-"
                    }}
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <el-row>
          <h4>Client</h4>
        </el-row>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Client List">
                <el-button style="width: 100%" @click="handleClientList(false)"
                  >View</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <h4>Status</h4>
        </el-row>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Last Success Login" prop="lastLogin">
                <p>
                  {{
                    formAccount.lastLogin
                      ? $commonjs.paramFormatDate(formAccount.lastLogin)
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Last Password Update" prop="lastPwd">
                <p>
                  {{
                    formAccount.lastPwd
                      ? $commonjs.paramFormatDate(formAccount.lastPwd)
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Account Status" prop="userStatus">
                <p
                  :style="
                    formAccount.userStatus == 'ACTIVATED'
                      ? 'color:rgb(0,127,80)'
                      : formAccount.userStatus == 'OPENED'
                      ? 'color:rgb(85,130,160)'
                      : 'color:rgb(255,0,0)'
                  "
                >
                  {{ $commonjs.userStatusMap(formAccount.userStatus) }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Activation Date & Time" prop="activationAt">
                <p>
                  {{
                    formAccount.activationAt
                      ? $commonjs.paramFormatDate(formAccount.activationAt)
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Remarks" prop="userTypeRemarks">
                <el-input
                  v-model="formAccount.userTypeRemarks"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <!-- <el-form
        label-width="50%"
        label-position="left"
        ref="formAccount"
        :model="formAccount"
        :rules="formAccountRules"
      >
        <el-row>
          <h4>Personal Information</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Vendor ID/Employee ID" prop="clientID">
              <p>{{ formAccount.clientID }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formAccount.userStatus != 'OPENED'">
            <el-form-item label="Username" prop="userName">
              <p>{{ formAccount.userName }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50" v-if="formAccount.isDummyUser">
          <el-col :span="12">
            <el-form-item label="Dummy account type" prop="userType">
              <p>{{ $commonjs.userTypeMap(formAccount.userType) }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Dummy account remarks" prop="userTypeRemarks">
              <el-input
                v-model="formAccount.userTypeRemarks"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12" v-if="formAccount.sfRecordType !== 'CP'">
            <el-form-item
              v-if="formAccount.isDummyUser"
              label="Last Name"
              prop="lastName"
              :error="formAccount.lastName ? '' : 'Last Name cannot be empty'"
            >
              <el-input
                v-model="formAccount.lastName"
                maxlength="50"
              ></el-input>
            </el-form-item>

            <el-form-item v-else label="Last Name">
              <p>{{ formAccount.lastName ? formAccount.lastName : "-" }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formAccount.sfRecordType !== 'CP'">
            <el-form-item label="First Name" prop="firstName">
              <el-input
                v-model="formAccount.firstName"
                maxlength="50"
                v-if="formAccount.isDummyUser"
              ></el-input>
              <p v-else>
                {{ formAccount.firstName ? formAccount.firstName : "-" }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12" v-if="formAccount.sfRecordType !== 'CP'">
            <el-form-item label="Middle Name" prop="middleName">
              <el-input
                v-model="formAccount.middleName"
                maxlength="50"
                v-if="formAccount.isDummyUser"
              ></el-input>
              <p v-else>
                {{ formAccount.middleName ? formAccount.middleName : "-" }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12" v-if="!formAccount.isDummyUser">
            <el-form-item
              label="Salesforce Email address"
              prop="salesforceEmail"
            >
              <p>
                {{
                  formAccount.salesforceEmail
                    ? formAccount.salesforceEmail
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!formAccount.isDummyUser">
            <el-form-item label="Salesforce Name" prop="salesforceName">
              <p>{{ formAccount.name ? formAccount.name : "-" }}</p>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="50">
          <el-col :span="12" v-if="!formAccount.isDummyUser">
            <el-form-item label="Salesforce Phone" prop="salesforcePhone">
              <p>
                {{
                  formAccount.cellularphone ? formAccount.cellularphone : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!formAccount.isDummyUser">
            <el-form-item label="Legal Name" prop="legalName">
              <p>{{ formAccount.legalName ? formAccount.legalName : "-" }}</p>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="50">
          <el-col :span="12" v-if="!formAccount.isDummyUser">
            <el-form-item label="Salesforce Status" prop="salesforceStatus">
              <p>
                {{
                  formAccount.salesforceStatus
                    ? formAccount.salesforceStatus
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>
        <el-row>
          <h4>Sales Information</h4>
        </el-row>
        <div v-if="formAccount.isDummyUser">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Sales Office*" prop="salesOffice">
                <el-select
                  v-model="formAccount.salesOffice"
                  @change="changeSalesOffice"
                  :disabled="$store.state.userLevel >= 2"
                >
                  <el-option
                    v-for="(item, index) in salesOfficeList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Region" prop="region">
                <el-select v-model="formAccount.region">
                  <el-option
                    v-for="(item, index) in regionList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Sales Representative Name"
                prop="representativeName"
              >
                <el-input v-model="formAccount.representativeName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Sales Office">
                <p>{{ $commonjs.salesOfficeMap(formAccount.salesOffice) }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Salesforce Region">
                <p>
                  {{
                    formAccount.salesforceRegion
                      ? formAccount.salesforceRegion
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Region">
                <p>{{ $commonjs.regionMap(formAccount.region) }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Sales Representative Name">
                <p>
                  {{
                    formAccount.representativeName
                      ? formAccount.representativeName
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="50">
            <el-col :span="12" v-if="formAccount.sfRecordType === 'CP'">
              <el-form-item label="Parent Account" prop="salseforceParentName">
                <p>{{ safeGetNameField(formAccount.salesforceParent) }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Record Type" prop="salseforceRecordType">
                <p>{{ safeGetNameField(formAccount.salesforceRecordType) }}</p>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="50">
            <el-col
              :span="12"
              v-if="!['PB', 'AM'].includes(formAccount.sfRecordType)"
            >
              <el-form-item label="Referred By" prop="salseforceReferredByBDLv">
                <p>
                  {{
                    formAccount.salseforceReferredByBDLv
                      ? formAccount.salseforceReferredByBDLv
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formAccount.sfRecordType !== 'IP'">
              <el-form-item label="Account Name" prop="salseforceAccountName">
                <p>{{ safeGetNameField(formAccount.salesforceAccount) }}</p>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="!formAccount.isDummyUser">
          <el-divider></el-divider>
          <el-row :gutter="50">
            <el-col :span="6">
              <h4>Client List</h4>
            </el-col>
            <el-col :span="6">
              <el-button style="width: 100%" @click="handleClientList(false)"
                >View</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div v-if="!formAccount.isDummyUser && formAccount.booklets">
          <el-divider></el-divider>
          <el-row>
            <h4>Booklet</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                :label="$commonjs.languageMap('EN')"
                prop="bookletEn"
              >
                <p style="word-break: break-all">
                  {{ formAccount.booklets.EN ? formAccount.booklets.EN : "-" }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$commonjs.languageMap('JA')"
                prop="bookletEn"
              >
                <p style="word-break: break-all">
                  {{ formAccount.booklets.JA ? formAccount.booklets.JA : "-" }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                :label="$commonjs.languageMap('ZH_CN')"
                prop="bookletEn"
              >
                <p style="word-break: break-all">
                  {{
                    formAccount.booklets.ZH_CN
                      ? formAccount.booklets.ZH_CN
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$commonjs.languageMap('ZH_HK')"
                prop="bookletEn"
              >
                <p style="word-break: break-all">
                  {{
                    formAccount.booklets.ZH_HK
                      ? formAccount.booklets.ZH_HK
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-divider></el-divider>
        <el-row>
          <h4>Status</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              label="Last success login date & time"
              prop="lastLogin"
            >
              <p>
                {{
                  formAccount.lastLogin
                    ? $commonjs.paramFormatDate(formAccount.lastLogin)
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Last password update date & time"
              prop="lastPwd"
            >
              <p>
                {{
                  formAccount.lastPwd
                    ? $commonjs.paramFormatDate(formAccount.lastPwd)
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="User Status" prop="userStatus">
              <p
                :style="
                  formAccount.userStatus == 'ACTIVATED'
                    ? 'color:rgb(0,127,80)'
                    : formAccount.userStatus == 'OPENED'
                    ? 'color:rgb(85,130,160)'
                    : 'color:rgb(255,0,0)'
                "
              >
                {{ $commonjs.userStatusMap(formAccount.userStatus) }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Remarks"
              prop="remarks"
              v-if="formAccount.userStatus != 'OPENED'"
            >
              <el-input
                v-model="formAccount.remarks"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Last update by" prop="lastUpdate">
              <p>{{ formAccount.lastUpdate ? formAccount.lastUpdate : "-" }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              label="User Activation Date & Time"
              prop="activationAt"
            >
              <p>{{ formAccount.activationAt }}</p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form> -->
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col :span="4">
        <el-button
          v-if="showSave"
          class="reset"
          style="width: 100%"
          @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col :span="4" v-if="formAccount.userStatus != 'OPENED'">
        <el-button
          v-if="showSave"
          type="primary"
          style="width: 100%"
          @click="handleSave"
          >Save</el-button
        >
      </el-col>
    </el-row>
    <el-dialog
      title="Client List"
      :visible.sync="clientListPopup"
      width="90%"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="top"
        ref="searchClientForm"
        :model="searchClientForm"
        :inline="true"
        style="text-align: left"
        class="demo-form-inline"
      >
        <el-form-item prop="name">
          <el-input
            v-model="searchClientForm.name"
            placeholder="Client ID / Name"
            style="width: 200px"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="search" @click="getClientList">Search</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="reset" @click="resetSearchForm">Reset</el-button>
        </el-form-item>
        <el-button style="float: right" @click="handleExport">Export</el-button>
        <div style="float: right; margin-right: 30px; margin-top: 10px">
          <el-dropdown trigger="click" ref="filter">
            <span class="el-dropdown-link sortbox" style="cursor: pointer">
              <em class="filter"></em>
              Filter
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-form
                ref="formFilter"
                :model="filterFrom"
                style="width: 300px; padding: 14px 24px"
              >
                <el-form-item label="Region" style="margin-bottom: 12px">
                  <el-select
                    v-model="filterFrom.region"
                    :popper-append-to-body="false"
                    multiple
                    clearable
                  >
                    <el-option value="All">All</el-option>
                    <el-option
                      v-for="(item, index) in RegionList"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Language" style="margin-bottom: 12px">
                  <el-select
                    v-model="filterFrom.language"
                    :popper-append-to-body="false"
                    multiple
                    clearable
                  >
                    <el-option value="All">All</el-option>
                    <el-option
                      v-for="(item, index) in languageList"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Project" style="margin-bottom: 12px">
                  <el-select
                    v-model="filterFrom.project"
                    :popper-append-to-body="false"
                    filterable
                    multiple
                    clearable
                  >
                    <el-option value="All">All</el-option>
                    <el-option
                      v-for="(item, index) in ProductsList"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Master Plan" style="margin-bottom: 12px">
                  <el-select
                    v-model="filterFrom.masterPlan"
                    :popper-append-to-body="false"
                    filterable
                    multiple
                    clearable
                  >
                    <el-option value="All">All</el-option>
                    <el-option
                      v-for="(item, index) in masterPlanIDList"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <div class="filterButton">
                  <el-form-item style="margin-right: 15px; margin-bottom: 0">
                    <el-button
                      class="reset"
                      @click="
                        $refs.filter.hide();
                        resetForm();
                      "
                      >Reset</el-button
                    >
                  </el-form-item>
                  <el-form-item style="margin-bottom: 0">
                    <el-button
                      type="primary"
                      class="search"
                      @click="
                        () => {
                          $refs.filter.hide();
                          getClientList();
                        }
                      "
                      >Apply</el-button
                    >
                  </el-form-item>
                </div>
              </el-form>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-form>
      <el-table :data="clientList" max-height="490px">
        <el-table-column prop="clientID" label="Client ID" width="80">
          <template slot-scope="scope">{{
            scope.row.clientID ? scope.row.clientID : "-"
          }}</template>
        </el-table-column>
        <el-table-column label="Name">
          <template slot-scope="scope">
            {{
              scope.row.lastName +
              ", " +
              scope.row.firstName +
              " " +
              scope.row.middleName
            }}
          </template>
        </el-table-column>
        <el-table-column label="Sales Office" width="100">
          <template slot-scope="scope">{{
            $commonjs.salesOfficeMap(scope.row.salesOffice)
          }}</template>
        </el-table-column>
        <el-table-column label="Region" width="100">
          <template slot-scope="scope">{{
            $commonjs.regionMap(scope.row.region)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="representative"
          label="Sales Representative Name"
          :formatter="$commonjs.tableEmptyField"
        ></el-table-column>
        <el-table-column
          prop="salseforceServicingChannelType"
          label="Servicing Channel Type"
          :formatter="$commonjs.tableEmptyField"
        ></el-table-column>
        <el-table-column
          prop="salseforceServicingChannelName"
          label="Referral Company / Individual Planner"
          :formatter="$commonjs.tableEmptyField"
        ></el-table-column>
        <el-table-column
          prop="salseforceServicingFinancialPlanner"
          label="Referral Planner / Broker"
          :formatter="$commonjs.tableEmptyField"
        ></el-table-column>
        <el-table-column
          prop="salseforceReferredByIfa"
          label="Sub-Referral Company"
          :formatter="$commonjs.tableEmptyField"
        ></el-table-column>
        <el-table-column
          prop="salseforceReferredByPlanner"
          label="Sub-Referral Planner"
          :formatter="$commonjs.tableEmptyField"
        ></el-table-column>
        <el-table-column
          prop="salseforceReferredByClientLv"
          label="Referred by (Client Lv)"
          :formatter="$commonjs.tableEmptyField"
        ></el-table-column>
        <el-table-column
          prop="language"
          label="Language"
          :formatter="$commonjs.tableEmptyField"
        ></el-table-column>
        <el-table-column label="Master Plan">
          <template slot-scope="scope">
            <div v-if="scope.row.masterPlanNames.length < 6">
              <span v-for="item in scope.row.masterPlanNames" :key="item.id">
                {{ item }},
              </span>
            </div>
            <div v-else>
              <div v-show="!masterView">
                {{ scope.row.masterPlanNames[0] }},
                {{ scope.row.masterPlanNames[1] }},
                {{ scope.row.masterPlanNames[2] }},
                {{ scope.row.masterPlanNames[3] }},
                {{ scope.row.masterPlanNames[4] }},
              </div>

              <div v-show="masterView">
                <span v-for="item in scope.row.masterPlanNames" :key="item.id">
                  {{ item }},
                </span>
              </div>

              <el-button
                v-if="masterView"
                type="text"
                slot="reference"
                @click="less"
                class="btntext"
                >View Less</el-button
              >
              <el-button
                v-else
                class="btntext"
                type="text"
                slot="reference"
                @click="more"
                >View More</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="projects" label="Project">
          <template slot-scope="scope">
            <div v-if="scope.row.projects.length < 6">
              <span v-for="item in scope.row.projects" :key="item.id">
                {{ item }},
              </span>
            </div>
            <div v-else>
              <div v-show="!projectView">
                {{ scope.row.projects[0] }}, {{ scope.row.projects[1] }},
                {{ scope.row.projects[2] }}, {{ scope.row.projects[3] }},
                {{ scope.row.projects[4] }},
              </div>

              <div v-show="projectView">
                <span v-for="item in scope.row.projects" :key="item.id">
                  {{ item }},
                </span>
              </div>

              <el-button
                v-if="projectView"
                type="text"
                slot="reference"
                @click="projectshutView"
                class="btntext"
                >View Less</el-button
              >
              <el-button
                v-else
                class="btntext"
                type="text"
                slot="reference"
                @click="projectshowView"
                >View More</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Status" width="70">
          <template slot-scope="scope">
            <span :class="'userstatus-' + scope.row.userStatus">
              {{ $commonjs.userStatusMap(scope.row.userStatus) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Operation" width="100">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="Edit"
              placement="top"
            >
              <em class="edit" @click="handleEditClient(scope.row)"></em>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <app-pagination
        @size-change="
          (v) => {
            currentSize = v;
            currentPage = 1;
            getClientList();
          }
        "
        @current-change="
          (v) => {
            currentPage = v;
            getClientList();
          }
        "
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]"
        :total="total"
        :page-size="currentSize"
      ></app-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  appUserEdit,
  getSalesOffice,
  getSalesRegion,
  bizUserDetail,
  bizUserClientList,
  bizUserClientExport,
  appProducts,
  bizUserClientListMasterPlan,
  bizUserClientListProject,
  bizUserClientListRegion,
} from "@/request/api";
export default {
  name: "editBizUser",
  data() {
    return {
      ProductsList: null,
      masterPlanIDList: null,
      masterView: false,
      projectView: false,
      formAccountRules: this.$validation.appUserEdit,
      formAccount: {
        id: "",
        clientID: "",
        userName: "",
        userType: "",
        userTypeRemarks: "",
        firstName: "",
        lastName: "",
        middleName: "",
        dob: "",
        email: "",
        salesOffice: "",
        region: "",
        representativeName: "",
        salesforceLanguage: "",
        preferredLanguage: "",
        lastLogin: "",
        lastPwd: "",
        userStatus: "",
        remarks: "",
        lastUpdate: "",
        isDummyUser: false,
        salseforceServicingChannelType: "",
        salseforceServicingChannelName: "",
        salseforceServicingFinancialPlanner: "",
        salseforceReferredByIfa: "",
        salseforceReferredByPlanner: "",
        salseforceReferredByClientLv: "",
        sfUserType: undefined,
        sfRecordType: undefined,
        activationAt: "",
      },
      salesOfficeList: [],
      regionList: [],
      languageList: [
        { name: "English", code: "EN" },
        { name: "Traditional Chinese", code: "ZH_HK" },
        { name: "Simplified Chinese", code: "ZH_CN" },
        { name: "Japanese", code: "JA" },
      ],

      RegionList: [
        // { name: "Hong Kong", code: "HK" },
        // { name: "China", code: "ZH" },
        // { name: "Japan", code: "JP" },
        // { name: "Taiwan", code: "TW" },
        // { name: "UAE", code: "UAE" },
        // { name: "Singapore", code: "SG" },
        // { name: "Malaysia", code: "MY" },
        // { name: "Indonesia", code: "ID" },
      ],
      clientListPopup: false,
      clientList: [],
      total: 0,
      currentSize: 10,
      currentPage: 1,
      searchClientForm: {
        name: "",
      },
      filterFrom: {
        region: "All",
        language: "All",
        project: "All",
        masterPlan: "All",
      },

      sfRecordType: [
        { code: "CP", name: "Corporate Partner" },
        { code: "PB", name: "Planner / Broker" },
        { code: "IP", name: "Individual Partner" },
        { code: "AM", name: "Account Manager" },
      ],
      prevRoute: null,
      showSave: true,
    };
  },
  methods: {
    getDetail() {
      bizUserDetail(this.$route.params.sfUserType, this.$route.params.id).then(
        (res) => {
          const content = res.data.payload;
          this.formAccount.id = content.id;
          this.formAccount.clientID = content.clientID;
          this.formAccount.userName = content.username;
          this.formAccount.userType = content.userType;
          this.formAccount.email = content.email;
          this.formAccount.userTypeRemarks = content.userTypeRemark;
          this.formAccount.remarks = content.userStatusRemark;
          this.formAccount.firstName = content.firstName;
          this.formAccount.lastName = content.lastName;
          this.formAccount.middleName = content.middleName;
          this.formAccount.dob = content.dob;
          this.formAccount.salesOffice = content.salesOffice;
          this.formAccount.booklets = content.booklets;
          this.changeSalesOffice(content.salesOffice, () => {
            this.formAccount.region = content.region;
          });
          // this.formAccount.region = content.region;
          this.formAccount.representativeName = content.representative;
          this.formAccount.salesforceLanguage = content.salesforceLanguage;
          this.formAccount.salesforceEmail = content.salesforceEmail;
          this.formAccount.salesforceOffice = content.salesforceOffice;
          this.formAccount.salesforceRegion = content.salesforceRegion;
          this.formAccount.preferredLanguage = content.language;
          this.formAccount.lastLogin = content.lastLoginAt;
          this.formAccount.lastPwd = content.lastPwdUpdatedAt;
          this.formAccount.userStatus = content.userStatus;
          var market = content.pushSettings.filter(
            (item) => item.notificationType === "MARKET"
          );
          this.formAccount.marketUpdates = market[0].isOn ? "ON" : "OFF";
          var corporate = content.pushSettings.filter(
            (item) => item.notificationType === "CORPORATE"
          );
          this.formAccount.corporate = corporate[0].isOn ? "ON" : "OFF";
          this.formAccount.lastUpdate =
            content.updatedByName != ""
              ? content.updatedByName +
                ", " +
                this.$commonjs.paramFormatDate(content.cmsUpdatedAt)
              : "";
          this.formAccount.isDummyUser = content.isDummyUser;
          this.formAccount.salseforceServicingChannelType =
            content.salseforceServicingChannelType
              ? content.salseforceServicingChannelType
              : "-";
          this.formAccount.salseforceServicingChannelName =
            content.salseforceServicingChannelName
              ? content.salseforceServicingChannelName
              : "-";
          this.formAccount.salseforceServicingFinancialPlanner =
            content.salseforceServicingFinancialPlanner
              ? content.salseforceServicingFinancialPlanner
              : "-";
          this.formAccount.salseforceReferredByIfa =
            content.salseforceReferredByIfa
              ? content.salseforceReferredByIfa
              : "-";
          this.formAccount.salseforceReferredByPlanner =
            content.salseforceReferredByPlanner
              ? content.salseforceReferredByPlanner
              : "-";
          this.formAccount.salseforceReferredByClientLv =
            content.salseforceReferredByClientLv
              ? content.salseforceReferredByClientLv
              : "-";
          this.formAccount.salseforceReferredByBDLv =
            content.salseforceReferredByBDLv
              ? content.salseforceReferredByBDLv
              : "-";
          this.formAccount.cellularphone = content.cellularphone
            ? content.cellularphone
            : "-";
          this.formAccount.phone = content.phone ? content.phone : "-";
          this.formAccount.name = content.name ? content.name : "-";
          this.formAccount.salesforceAccount = content.salesforceAccount
            ? content.salesforceAccount
            : "-";
          this.formAccount.salesforceRecordType = content.salesforceRecordType
            ? content.salesforceRecordType
            : "-";
          this.formAccount.salesforceParent = content.salesforceParent
            ? content.salesforceParent
            : "-";
          this.formAccount.salesforceStatus = content.salesforceStatus
            ? content.salesforceStatus
            : "-";
          this.formAccount.legalName = content.legalName
            ? content.legalName
            : "-";
          this.formAccount.sfUserType = content.sfUserType
            ? content.sfUserType
            : undefined;
          const mSfRecordType = this.safeGetNameField(
            content.salesforceRecordType
          );
          const recordTypeObj = this.sfRecordType.find(
            (x) => x.name === mSfRecordType
          );
          this.formAccount.sfRecordType = recordTypeObj
            ? recordTypeObj.code
            : undefined;
          this.formAccount.activationAt = content.activationAt
            ? content.activationAt
            : "-";
        }
      );
    },

    // getProducts() {
    //   appProducts().then((res) => {
    //     console.log(res);
    //     var option = [];
    //     var id = [];
    //     res.data.map((item) => {
    //       option.push({ code: item.productNumber, name: item.productName });
    //       id.push({ code: item.masterPlanID, name: item.masterPlanName });
    //     });
    //     this.ProductsList = option;
    //     this.masterPlanIDList = id;
    //   });
    // },

    resetForm() {
      this.filterFrom.region = [];
      this.filterFrom.language = [];
      this.filterFrom.project = [];
      this.filterFrom.masterPlan = [];
      this.getClientList();
    },

    more() {
      this.masterView = true;
    },
    less() {
      this.masterView = false;
    },

    projectshowView() {
      this.projectView = true;
    },
    projectshutView() {
      this.projectView = false;
    },

    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },

    getFilterConfig() {
      getSalesOffice().then((res) => {
        this.salesOfficeList = res.data.payload;
      });
    },
    changeSalesOffice(v, callback) {
      this.clearRegion();
      getSalesRegion(v).then((res) => {
        this.regionList = res.data.payload;
        if (callback) callback();
      });
    },
    clearRegion() {
      this.regionList = [];
      this.$set(this.formAccount, "region", "");
    },
    handleCancel() {
      this.$router.push("/businessPartnerManagement");
    },
    handleSave() {
      this.$refs.formAccount.validate((valid) => {
        if (valid) {
          let params;
          if (this.formAccount.isDummyUser) {
            params = {
              clientID: this.formAccount.clientID,
              username: this.formAccount.userName,
              email: this.formAccount.email,
              userStatusRemark: this.formAccount.remarks,
              userTypeRemark: this.formAccount.userTypeRemarks,
              firstName: this.formAccount.firstName,
              lastName: this.formAccount.lastName,
              middleName: this.formAccount.middleName,
              dob: this.$commonjs.paramFormatDate(this.formAccount.dob, true),
              // salesforceLanguage:this.formAccount.salesforceLanguage,
              salesOffice: this.formAccount.salesOffice,
              region: this.formAccount.region,
              representative: this.formAccount.representativeName,
            };
          } else {
            params = {
              clientID: this.formAccount.clientID,
              // username:this.formAccount.userName,
              sfUserType: this.formAccount.sfUserType,
              email: this.formAccount.email,
              userStatusRemark: this.formAccount.remarks,
            };
            if (this.formAccount.userStatus !== "OPENED")
              params["username"] = this.formAccount.userName;
          }
          appUserEdit(this.formAccount.clientID, params).then((res) => {
            console.log(res);
            if (res.data.status == "00") {
              this.$message.success("The changes have been saved");
              // this.getDetail();
              this.$router.push({
                name: "appUser",
                params: {
                  update: true,
                },
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.$message.error(
            "Please check the form and fill in correct format"
          );
        }
      });
    },
    handleClientList(showMore) {
      this.searchClientForm.name = "";
      this.getClientList((data) => {
        this.clientListPopup = true;
      });
    },
    getClientList(callback) {
      const mId = this.$route.params.id;
      const sfUserType = this.formAccount.sfUserType;
      const mParam = {
        page: this.currentPage - 1,
        size: this.currentSize,
        name: this.searchClientForm.name ? this.searchClientForm.name : "",
        region: this.filterFrom.region != "All" ? this.filterFrom.region : "",
        primaryLanguage:
          this.filterFrom.language != "All" ? this.filterFrom.language : "",
        projectCodes:
          this.filterFrom.project != "All" ? this.filterFrom.project : "",
        masterPlanIds:
          this.filterFrom.masterPlan != "All" ? this.filterFrom.masterPlan : "",
      };
      console.log(mParam);
      bizUserClientList(sfUserType, mId, mParam).then((res) => {
        if (res) {
          const content = res.data.content;

          // for (let i = 0; i < content.length; i++) {
          //   const mas = content[i].masterPlanNames;
          //   content[i].masterPlanIdsjoin = mas.join(",");
          // }
          // for (let i = 0; i < content.length; i++) {
          //   const pro = content[i].projects;
          //   content[i].projectsjoin = pro.join(",");
          // }
          this.clientList = content;
          this.total = res.data.totalElements;
        } else {
          this.$message.error(res.data.msg);
        }

        if (typeof callback === "function") callback();
      });

      // this.getProducts();
    },
    handleEditClient(row) {
      this.$router.push({ path: "/editUser/" + row.clientID });
    },
    resetSearchForm() {
      if (this.$refs.searchClientForm)
        this.$refs.searchClientForm.resetFields();
      this.searchClientForm.name = "";
      this.getClientList();
    },
    safeGetNameField(mField) {
      if (
        typeof mField === "object" &&
        mField !== null &&
        mField.hasOwnProperty("name")
      ) {
        return mField.name;
      } else if (typeof mField === "string" && mField.trim().length > 0) {
        return mField;
      } else {
        return "-";
      }
    },
    handleExport() {
      const mId = this.$route.params.id;
      const sfUserType = this.formAccount.sfUserType;
      var data = {
        name: this.searchClientForm.name ? this.searchClientForm.name : "",
        // sort: ["lastLoginAt,desc", "id,asc"],
        region: this.filterFrom.region != "All" ? this.filterFrom.region : [],
        primaryLanguage:
          this.filterFrom.language != "All" ? this.filterFrom.language : [],
        projectCodes:
          this.filterFrom.project != "All" ? this.filterFrom.project : [],
        masterPlanIds:
          this.filterFrom.masterPlan != "All" ? this.filterFrom.masterPlan : [],
        sort: "id,desc",
      };
      bizUserClientExport(sfUserType, mId, data).then((res) => {});
    },

    filterList() {
      const mId = this.$route.params.id;
      const sfUserType = this.formAccount.sfUserType;
      bizUserClientListMasterPlan(sfUserType, mId).then((res) => {
        console.log(res);
        var masterPlanIDList = [];
        res.data.map((item) => {
          masterPlanIDList.push({ code: item.code, name: item.nameEn });
        });
        this.masterPlanIDList = masterPlanIDList;
      });

      bizUserClientListProject(sfUserType, mId).then((res) => {
        console.log(res);
        var ProductsList = [];
        res.data.map((item) => {
          ProductsList.push({ code: item.code, name: item.nameEn });
        });
        this.ProductsList = ProductsList;
      });

      bizUserClientListRegion(sfUserType, mId).then((res) => {
        console.log(res);

        var RegionList = [];
        res.data.map((item) => {
          RegionList.push({ code: item.code, name: item.name });
        });
        this.RegionList = RegionList;
      });
    },
  },
  created: function () {
    this.$commonjs.initRegionsMap();
    this.getDetail();
    this.getFilterConfig();
    this.showBtn("BUSINESS_PARTNER_WRITE");
    this.filterList();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "bizUser") {
      this.prevRoute.meta.keepAlive = false;
    }
    next();
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.TabButton {
  background: rgb(247, 247, 249);
  color: rgb(85, 130, 160);
  border: 1px solid rgb(247, 247, 249);
}
.activeTabButton {
  background: rgb(85, 130, 160);
  color: #fff;
  border: 1px solid rgb(85, 130, 160);
}
.userstatus-OPENED {
  color: rgb(85, 130, 160);
}
.userstatus-ACTIVATED {
  color: rgb(0, 127, 80);
}
.userstatus-SUSPENDED {
  color: rgb(255, 0, 0);
}
.border-box {
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.border-boxshadow {
  padding: 20px;
  margin-bottom: 30px;
  border: 1px solid rgba(219, 223, 227, 0.3);
  box-shadow: 0px 0px 4px 1px rgb(0 0 0 / 50%);
}

.filterButton {
  display: flex;
  justify-content: flex-end;
}

.btntext {
  border-color: transparent;
  font-weight: bold;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/bizUser/EditBizUser.vue